import React from 'react'
import {
	useDispatch,
	useSelector
} from 'react-redux'
import Toast from 'react-bootstrap/Toast'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import Button from 'react-bootstrap/Button'
import {selectAllReactions} from './reactionsSlice'
import {reactToGroupFeedNotification} from "../groupFeed/groupFeedSlice"
import {fullBasePath} from '../../util/util'

export const checkHasReactions = reactions =>(
	Object.values(reactions).reduce((total,reaction)=>total+reaction.count,0) > 0
)

const iconMap = {
	'thumbs up':'👍',
	'grin-stars':'🤩',
	'grin':'😄',
	'clap':'👏',
	'party':'🎉'
}

const ReactionsSummary = ({reactions}) => {
	return (
		Object.values(reactions)
			.filter(reaction=>reaction.count>0)
			.map(reaction=>(
				<span key={reaction.id} className="ml-2">
					<span className="mr-2">{iconMap[reaction.name]}</span>
					<span>{reaction.count}</span>
				</span>
			))
	)
}

const Reactions = ({children,reactions,onReaction,onlyShowTotals,disabled=false}) => {
	const dispatch = useDispatch()
	const reactionOptions = useSelector(selectAllReactions)
	const hasReactions = checkHasReactions(reactions)
	const buttonText = (
		hasReactions?
		<ReactionsSummary reactions={reactions} />:
		<span className="mr-2">{iconMap['thumbs up']}</span>
	)
	if (onlyShowTotals && !hasReactions) return null
	return (
		<div className="text-right">
			<OverlayTrigger rootClose trigger="click" overlay={
				<Popover>
					<Popover.Content>
						<ButtonGroup>
							{reactionOptions.map( reaction => (
								<Button 
									disabled={disabled}
									key={reaction.id}
									onClick={()=>{
										onReaction(reaction); 
										// this will close the popover
										document.body.click()}}
									size="sm" 
									variant="outline-dark">
									{iconMap[reaction.name]}
								</Button>
							))}
						</ButtonGroup>
					</Popover.Content>
				</Popover>
			}>
				<button disabled={disabled} style={{border:'1px solid #ccc',background:'#fff',padding:'2px 4px',borderRadius:'5px'}}>
					{children}{buttonText}
				</button>
			</OverlayTrigger>
		</div>
	)
}

export default Reactions

